export default __webpack_public_path__ + "static/media/9.8cc09c68.jpg";